import { render, staticRenderFns } from "./songs-correction-index.vue?vue&type=template&id=e53dc214&scoped=true&"
import script from "./songs-correction-index.vue?vue&type=script&lang=js&"
export * from "./songs-correction-index.vue?vue&type=script&lang=js&"
import style0 from "./songs-correction-index.vue?vue&type=style&index=0&id=e53dc214&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53dc214",
  null
  
)

export default component.exports